import { COLOR_PALETTE } from 'constants/ui';

export const containerStyles = {
  display: 'flex',
  flexDirection: 'column',
  gap: '8px',
  padding: '16px 16px 16px 20px',
  borderRadius: '4px 8px 8px 4px',
  backgroundColor: COLOR_PALETTE.RED[1],
  position: 'relative',
  boxShadow: ({ palette }) => palette.shadow.s,
  '&::before': {
    content: '""',
    position: 'absolute',
    top: 0,
    bottom: 0,
    left: 0,
    width: '4px',
    backgroundColor: COLOR_PALETTE.RED[7],
    borderRadius: '4px 0 0 4px',
  },
};

export const headerStyles = {
  display: 'flex',
  flexDirection: 'row',
  alignItems: 'flex-start',
  gap: '8px',
};

export const iconStyles = {
  display: 'flex',
  flexShrink: 0,
  color: COLOR_PALETTE.RED[7],
};

export const errorTextStyles = {
  color: COLOR_PALETTE.RED[7],
};

export const actionsStyles = {
  display: 'flex',
  flexDirection: 'row',
  gap: '8px',
  marginTop: '4px',
  alignItems: 'center',
};
